$(function () {
    $(".homebanner-slider-items").each(function () {
        var thisElement = $(this);
        var parentSlider = $(this).closest('.homebanner-slider');

        thisElement.slick({
            fade: false,
            dots: false,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            prevArrow: thisElement.closest('.homebanner-slider').find('.homebanner-slider-PrevButton'),
            nextArrow: thisElement.closest('.homebanner-slider').find('.homebanner-slider-NextButton'),
            appendDots: thisElement.closest('.homebanner-slider').find('.homebanner-slider-dots'),
            mobileFirst: true,
            responsive: [
                {
                breakpoint: 768,
                    settings: {
                        slidesToShow: 2
                    }                
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3
                    }                
                },
            ]
        });
    });

    if (document.querySelector('.homebanner:not(.__dark)')) {
        $('.burger').addClass('dark');
    } 

});